import React from 'react';
import ChannelPreferences from './ChannelPreferences';
import NotificationTopicToggle from './NotificationTopicToggle';
import { useFirebase } from '../../../../services/firebase';
import {
  ChannelClassification,
  IPreferenceTemplate,
  IRecipientPreference,
} from '@trycourier/react-hooks/typings/preferences/types';
import { UpdateRecipientPreferencesPayload } from '@trycourier/client-graphql';
import useUserChannelPreferences from '../../../../hooks/useUserChannelPreferences';

interface TopicProps {
  topic: IPreferenceTemplate;
  isAdmin: boolean;
  filteredChannels: ChannelClassification[];
  section: {
    hasCustomRouting: boolean;
  };
  recipientPreference?: IRecipientPreference;
  updateRecipientPreferences: (
    payload: UpdateRecipientPreferencesPayload
  ) => void;
}

const Topic: React.FC<TopicProps> = ({
  topic,
  isAdmin,
  filteredChannels,
  section,
  recipientPreference,
  updateRecipientPreferences,
}) => {
  const { currentUser } = useFirebase();
  const { channelPreferences, loadingState, updateUserChannelPreference } =
    useUserChannelPreferences({
      userId: currentUser!.uid,
      templateIds: [topic.templateId],
    });

  return (
    <>
      <NotificationTopicToggle
        topic={topic}
        isAdmin={isAdmin}
        defaultRoutingOptions={filteredChannels}
        defaultHasCustomRouting={section.hasCustomRouting}
        hasCustomRouting={recipientPreference?.hasCustomRouting || false}
        status={recipientPreference?.status}
        routingPreferences={recipientPreference?.routingPreferences ?? []}
        onChange={async (newStatus) => {
          return updateRecipientPreferences({
            hasCustomRouting: recipientPreference?.hasCustomRouting || false,
            templateId: topic.templateId,
            status: newStatus,
            routingPreferences:
              newStatus === 'OPTED_IN'
                ? recipientPreference?.routingPreferences
                : [],
          });
        }}
      />

      <ChannelPreferences
        topicDisabled={recipientPreference?.status === 'OPTED_OUT'}
        templateId={topic.templateId}
        channels={filteredChannels}
        channelPreferences={channelPreferences[topic.templateId]}
        updateUserChannelPreference={updateUserChannelPreference}
        loadingState={loadingState}
      />
    </>
  );
};

export default Topic;
